import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'projects-preview',
  templateUrl: './projects-preview.component.html',
  styleUrls: ['./projects-preview.component.scss']
})
export class ProjectsPreviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
